import {AfterContentChecked, AfterContentInit, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRowDef} from '@angular/material/table';
import TableDescriptor = WebAssembly.TableDescriptor;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tdo-table-column',
  templateUrl: './tdo-table-column.component.html',
  styleUrls: ['./tdo-table-column.component.scss']
})
export class TdoTableColumnComponent implements OnInit {
  @Input() columnDataName: string;
  @Input() propertyName: string;
  @Input() displayName: string;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() rowTemplate: TemplateRef<any>;
  @Input() targetObjectName: string;
  @Input() isSortable = false;
  @Input() dataType: string;

  constructor() { } 

  ngOnInit(): void {
  }
}
